import { LoadingOverlay } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { RevisionGetResponse } from 'api/actions/revision-get/revision-get-response';
import useDocumentGeneratorV2 from 'api/document-generator-v2/use-document-generator-v2';
import panic from 'errors/panic';
import { useEffect, useState } from 'react';

/**
 * Parameters of the PreviewTabContent component.
 */
export interface RevisionPreviewProps {
  revisionData: any;
  revision: RevisionGetResponse;
  height?: string;
}

/**
 * Content of the preview tab in the Electric revision form.
 */
export default function RevisionPreview({
  revisionData,
  revision,
  height = 'calc(100vh - 200px)',
}: RevisionPreviewProps) {
  const [preview, setPreview] = useState('');
  const [loading, { close: stopLoading }] = useDisclosure(true);
  const { generatePreview } = useDocumentGeneratorV2();
  const templateIsRenderable = Boolean(
    revision.revisionTemplate?.formScheme &&
      revision.revisionTemplate.templateScheme &&
      revision.revisionTemplate.visualData
  );

  useEffect(() => {
    if (!templateIsRenderable) {
      stopLoading();
      return;
    }

    generatePreview(revision, revisionData).then(setPreview).catch(panic).finally(stopLoading);
  }, [revisionData, revision]);

  if (!templateIsRenderable) {
    return <p role="alert">Náhľad nie je k dispozícii, pretože historická šablóna nemá úplné údaje na vykreslenie.</p>;
  }

  return (
    <>
      <LoadingOverlay visible={loading} />
      <iframe
        data-e2e-capture-role="viewport-height-content"
        title="Náhľad"
        srcDoc={preview}
        style={{ width: '100%', height, border: 'none' }}
      />
    </>
  );
}
